import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout/layout.component';
import { HomeComponent } from './pages/home/home.component';
import { LatestEventComponent } from './pages/latest-event/latest-event.component';
import { EventComponent } from './pages/event/event.component';
import { SpeakersComponent } from './pages/speakers/speakers.component';
import { ContactComponent } from './pages/contact/contact.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { DisruptKeralaComponent } from './pages/disrupt-kerala/disrupt-kerala.component';
import { TranscendIndiaComponent } from './pages/transcend-india/transcend-india.component';
import { EvolveIndiaComponent } from './pages/evolve-india/evolve-india.component';
import { BeyondComponent } from './pages/beyond-india/beyond.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: 'events/:id',
        component: EventComponent
      },
      {
        path: 'latest-event',
        component: LatestEventComponent
      },
      {
        path: 'speakers',
        component: SpeakersComponent
      },
      {
        path: 'contact',
        component: ContactComponent
      },
      {
        path: 'gallery',
        component: GalleryComponent
      },
      {
        path: 'not-found',
        component: NotFoundComponent
      },
      {
        path: 'disrupt-kerala',
        component: DisruptKeralaComponent
      },
      {
        path: 'beyond',
        component: BeyondComponent
      },
      {
        path: 'transcend-india',
        component: TranscendIndiaComponent
      },
      {
        path: 'evolve-india',
        component: EvolveIndiaComponent
      }
      
    ],
  },
  { path: '**', redirectTo: 'not-found' }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
